<template>
    <div class="flex flex-col">
        <div class="flex justify-between px-[4px]">
            <p class="text-[18px] text-primary font-semibold flex items-center">
                Location(s): {{ markers.length }}
            </p>
            <div></div>

            <button
                class="px-4 py-2 m-2 bg-red-700 text-white rounded-[5px]"
                @click="handleRemove()"
            >
                Delete All
            </button>
        </div>
        <div id="mapDiv" class="w-full h-full"></div>
    </div>
</template>

<script>
import { Loader } from "@googlemaps/js-api-loader";

export default {
    data() {
        return {
            map: null,
            markers: [],
            // mapDiv: null,
        };
    },
    async mounted() {
        const loader = new Loader({
            // apiKey: "AIzaSyBg8BVLET0Q-tHhAIgr-rmo3ddQiwgFgCo",
            apiKey: "AIzaSyCiLDfWO0dPjiiJEUqYWoM_LjUAJQOgyGk", //dkilo

            libraries: ["visualization"],
        });

        await loader.load();

        const CAIRO_BOUNDS = {
            north: 30.40506194749335,
            south: 29.79494721124095,
            west: 30.738370122571716,
            east: 31.892975122889684,
        };

        // const CAIRO_CENTER = new google.maps.LatLng(30.033333, 31.233334);
        const country = this.$store.state.auth.country_code;
        const centerCoordinates = this.getCenterCoordinates(country);


        this.map = new google.maps.Map(mapDiv, {
            mapTypeControl: false,
            streetViewControl: false,
            // clickableIcons: false,
            clickable: true,
            optimized: false,
            zoom: 10,
            disableDoubleClickZoom: true,
            draggable: true,
            animation: google.maps.Animation.DROP,
            minZoom: 7,
            maxZoom: 15,
            restriction: {
                // latLngBounds: CAIRO_BOUNDS,
                strictBounds: false,
            },
            center: centerCoordinates,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            mapTypeControlOptions: {
                mapTypeIds: [google.maps.MapTypeId.ROADMAP],
            },
            styles: [
                {
                    elementType: "geometry",
                    stylers: [
                        {
                            color: "#f5f5f5",
                        },
                    ],
                },
                {
                    elementType: "labels.icon",
                    stylers: [
                        {
                            visibility: "off",
                        },
                    ],
                },
                {
                    elementType: "labels.text.fill",
                    stylers: [
                        {
                            color: "#616161",
                        },
                    ],
                },
                {
                    elementType: "labels.text.stroke",
                    stylers: [
                        {
                            color: "#f5f5f5",
                        },
                    ],
                },
                {
                    featureType: "administrative.land_parcel",
                    elementType: "labels.text.fill",
                    stylers: [
                        {
                            color: "#bdbdbd",
                        },
                    ],
                },
                {
                    featureType: "poi",
                    elementType: "geometry",
                    stylers: [
                        {
                            color: "#eeeeee",
                        },
                    ],
                },
                {
                    featureType: "poi",
                    elementType: "labels.text.fill",
                    stylers: [
                        {
                            color: "#757575",
                        },
                    ],
                },
                {
                    featureType: "poi.park",
                    elementType: "geometry",
                    stylers: [
                        {
                            color: "#e5e5e5",
                        },
                    ],
                },
                {
                    featureType: "poi.park",
                    elementType: "labels.text.fill",
                    stylers: [
                        {
                            color: "#9e9e9e",
                        },
                    ],
                },
                {
                    featureType: "road",
                    elementType: "geometry",
                    stylers: [
                        {
                            color: "#ffffff",
                        },
                    ],
                },
                {
                    featureType: "road.arterial",
                    elementType: "labels.text.fill",
                    stylers: [
                        {
                            color: "#757575",
                        },
                    ],
                },
                {
                    featureType: "road.highway",
                    elementType: "geometry",
                    stylers: [
                        {
                            color: "#dadada",
                        },
                    ],
                },
                {
                    featureType: "road.highway",
                    elementType: "labels.text.fill",
                    stylers: [
                        {
                            color: "#616161",
                        },
                    ],
                },
                {
                    featureType: "road.local",
                    elementType: "labels.text.fill",
                    stylers: [
                        {
                            color: "#9e9e9e",
                        },
                    ],
                },
                {
                    featureType: "transit.line",
                    elementType: "geometry",
                    stylers: [
                        {
                            color: "#e5e5e5",
                        },
                    ],
                },
                {
                    featureType: "transit.station",
                    elementType: "geometry",
                    stylers: [
                        {
                            color: "#eeeeee",
                        },
                    ],
                },
                {
                    featureType: "water",
                    elementType: "geometry",
                    stylers: [
                        {
                            color: "#c9c9c9",
                        },
                    ],
                },
                {
                    featureType: "water",
                    elementType: "labels.text.fill",
                    stylers: [
                        {
                            color: "#9e9e9e",
                        },
                    ],
                },
            ],
        });
        // Add action buttons
        const addButton = document.createElement("button");
        addButton.textContent = "Add";
        addButton.title = "Add marker";
        addButton.type = "button";
        addButton.classList.add(
            "bg-primary",
            "px-4",
            "py-2",
            "text-lg",
            "text-white",
            "hover:bg-opacity-70",
            "shadow-md",
            "rounded-[5px]",
            "m-2"
        );
        addButton.addEventListener("click", this.handleAdd);
        this.map.controls[google.maps.ControlPosition.TOP_RIGHT].push(addButton);
    },

    methods: {
        handleAdd() {
            // Add a marker at the center of the map
            var mapCenter = this.map.getCenter();

            var marker = new google.maps.Circle({
                strokeColor: "#369DA3",
                strokeOpacity: 0.8,
                strokeWeight: 2,
                fillColor: "#369DA3",
                fillOpacity: 0.35,
                map: this.map,
                center: mapCenter,
                radius: 2500,
                draggable: true,
                geodesic: true,
                editable: true,
            });

            // google.maps.event.addListener(marker, "rightclick", () => {
            //     window.alert(`Map was clicked! ${marker.radius}`);
            //     marker.setMap(null);
            // });

            // google.maps.event.addListener(marker, "rightclick", function (mouseEvent) {
            // alert(`Right click triggered ${marker.radius}`);
            // });

            // var rightEvent = google.maps.event.addListener(marker, "rightclick", function (ev) {
            //     console.log("marker rightclick", marker.radius);
            //     console.log("marker rightclick EVENT", ev);
            // });

            // console.log("Mo2a");
            // console.log(rightEvent);
            // // rightEvent.remove();
            // console.log(rightEvent);

            google.maps.event.addListener(marker, "radius_changed", () => {
                // Upper boundary
                if (marker.radius > 5000) {
                    marker.radius = 5000;
                }
                // Lower boundary
                if (marker.radius < 500) {
                    marker.radius = 500;
                }
                this.handleMarkerChanged(marker);
            });

            google.maps.event.addListener(marker, "center_changed", () => {
                this.handleMarkerChanged(marker);
            });

            // google.maps.event.addListener(marker, "rightclick", () => {
            //     alert(`Map was clicked! ${marker.radius}`);
            //     marker.setMap(null);
            //     this.markers.splice(this.markers.indexOf(marker), 1);
            //     console.log("in", this.markers);
            // });
            // console.log("out", this.markers);

            this.markers.push(marker);
            //console.log("marker", this.markers);
            this.$emit("input", this.markers);
        },

        handleRemove() {
            // google.maps.event.addListener(marker, "rightclick", () => {
            //     window.alert(`Map was clicked! ${marker.radius}`);
            //     marker.setMap(null);
            // });
            // console.log("llllllll");
            // console.log(this.markers);
            for (let i = 0; i < this.markers.length; i++) {
                const element = this.markers[i];
                element.setMap(null);
            }
            this.markers = [];
            // console.log(this.markers);
        },

        // handleRemove( ) {
        //     // if (!confirm("Remove marker?")) return;
        //     marker.setMap(null);
        //     this.markers.splice(this.markers.indexOf(marker), 1);
        //     console.log(this.markers);
        //     console.log("IN", this.markers.indexOf(marker));

        //     // console.log("markers", this.markers);
        //     // this.$emit("input", this.markers);
        // },

        handleMarkerChanged(marker) {
            this.$emit("input", this.markers);
        },
        getCenterCoordinates() {
            const country = this.$store.state.auth.country_code;

            let center = { lat: 0, lng: 0 };

            if (country === "EG") {
                center = { lat: 30.033333, lng: 31.233334 }; // cairo center
            } else if (country === "SA") {
                center = { lat: 24.710387,   lng: 46.644294 }; //riydh center
            }

            return center;
        },
    },
};
</script>
